import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Loading from 'flow/components/ui-components/Loading';
import useAppContext from 'flow/hooks/useAppContext';
import { routes } from 'flow/types/routes';
import { electronActions, electronListeners } from 'flow/utils/electron-utils';

const InitialUpdate = () => {
    const { i18next } = useAppContext();
    const history = useHistory();
    const [updateAvailable, setUpdateAvailable] = useState(false);

    useEffect(() => {
        electronListeners.onUpdateAvailable(() => setUpdateAvailable(true));
        electronListeners.onNoUpdateAvailable(() =>
            history.push(routes['signin']),
        );
        electronListeners.onUpdateError(() => history.push(routes['signin']));
        electronActions.initialComponentMounted();
    }, []);

    return (
        <div className="flex flex-1 items-center justify-center bg-white">
            <div className="flex flex-col items-center gap-6 p-6">
                <Loading size={128} disableTimeout={true} />

                <div className="text-sm text-gray-800">
                    {updateAvailable
                        ? i18next.t(
                              'update.initial.downloading',
                              'Downloading update',
                          )
                        : i18next.t(
                              'update.initial.checking',
                              'Looking for updates',
                          )}
                </div>
            </div>
        </div>
    );
};

export default InitialUpdate;
